<template>
  <worker title="非在职员工信息管理" :fun-auth-other="funAuth" :job-type-c="['辞职辞退', '开除', '退休']"></worker>
</template>

<script>
import Worker from './worker'

export default {
  components: { Worker },
  computed: {
    funAuth () {
      return this.$authFunsProxy
    }
  }
}
</script>
